import React from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Login.css";
import {enterUserAction} from "../../redux/userWep";
import {CreateUser} from "../../redux/userWep";


const Login =()=> {
const dispatch =  useDispatch();
const userPortaf = useSelector(store=>store.userPort.loading) 


  const [formLogin, setFormLogin] = React.useState({
    user: "",
    password: "",

  });

  console.log("formLogin")
  const [acces, setAcces] = React.useState(false);

  const handleChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    setFormLogin({ ...formLogin, [name]: value });

    setAcces(false);
  };

  const validation = (e) => {
    if (formLogin.user === "admon" && formLogin.password === "1234") {
      setAcces(true);
    } else {
      alert("The User or Password not correct");
      setAcces(false);
    }

    setFormLogin({
      user: "",
      password: "",
    });
  };

  return (
    <form action="" className="form-style box container container-fluid ">
      <h2>Enter User </h2>

      <div className="input-group mb-3">
        <span> User </span>
        <input
          type="text"
          placeholder="Enter of User"
          className="form-control"
          onChange={handleChange}
          name="user"
          required
        />
      </div>
      <div className="input-group mb-3">
        <span> Password </span>
        <input
          type="password"
          placeholder="Enter of Password"
          onChange={handleChange}
          className="form-control"
          name="password"
          required
        />
      </div>

      {acces ? (
        <a href="/home" className="btn btn-primary m-2" onClick={()=>  dispatch(CreateUser(formLogin))}>
          Enter
        </a>
      ) : (
        <a className="btn btn-primary m-2" onClick={()=> dispatch(CreateUser(validation()))}>
          Enter
        </a>
      )}

      <a href="/home" className="btn btn-danger m-2">
        Cancel
      </a>
    </form>
  );
};

export default Login;
